import React from 'react';

export const ProjectAuthorChip = ({ name, gitHubLink }) => {
    const content = (
        <span className="inline-flex items-center rounded-full border border-earth-800 px-4 py-2 text-sm font-medium text-earth-900 transition-colors duration-200 hover:bg-earth-100 dark:border-earth-300 dark:text-earth-50 dark:hover:bg-earth-800">
            {name}
        </span>
    );

    if (!gitHubLink) {
        return content;
    }

    return (
        <a href={gitHubLink} target="_blank" rel="noreferrer" aria-label={`${name} GitHub profile`}>
            {content}
        </a>
    );
};
